import React, {useState} from 'react';
import {Card, Form, Input, Button, Typography, message} from 'antd';
import {UserOutlined, LockOutlined, MailOutlined} from '@ant-design/icons';
import {Link, useNavigate} from 'react-router-dom';
import {authApi} from '@/api/auth';
import type {RegisterPayload} from '@/types/auth.types';
import {
	ContainerCard_BodyStyles,
	ContainerCardStyles,
	ContainerStyles,
	LoginRedirectStyles,
	RegisterBtnStyles,
	TitleContainerStyles,
	TitleStyles,
} from './Register.styles';
import {confirmPasswordRules, emailRules, nameRules, passwordRules} from './Register.rules';

const {Title, Text} = Typography;

const Register: React.FC = () => {
	const navigate = useNavigate();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	const onFinish = async (values: RegisterPayload) => {
		setLoading(true);

		try {
			const {data, error, status} = await authApi.register({
				name: values.name,
				email: values.email,
				password: values.password,
			});

			if (error) {
				message.error(error.message || 'Ошибка регистрации');
				return;
			}

			if (status === 201 && data) {
				message.success('Регистрация успешна');
				navigate('/login');
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<div style={ContainerStyles}>
			<Card style={ContainerCardStyles} styles={{body: ContainerCard_BodyStyles}}>
				<div style={TitleContainerStyles}>
					<Title level={3} style={TitleStyles}>
						Регистрация
					</Title>
					<Text type="secondary">Создайте аккаунт для работы с приложением</Text>
				</div>
				<Form
					form={form}
					name="register"
					layout="vertical"
					size="large"
					onFinish={onFinish}
					requiredMark={false}
				>
					<Form.Item name="name" label="Имя" rules={nameRules}>
						<Input prefix={<UserOutlined />} placeholder="Иван Иванов" />
					</Form.Item>
					<Form.Item name="email" label="Email" rules={emailRules}>
						<Input prefix={<MailOutlined />} placeholder="user@example.com" />
					</Form.Item>
					<Form.Item name="password" label="Пароль" rules={passwordRules}>
						<Input.Password prefix={<LockOutlined />} placeholder="Пароль" />
					</Form.Item>
					<Form.Item
						name="confirm"
						label="Подтверждение пароля"
						dependencies={['password']}
						rules={confirmPasswordRules}
					>
						<Input.Password prefix={<LockOutlined />} placeholder="Повторите пароль" />
					</Form.Item>
					<Form.Item style={RegisterBtnStyles}>
						<Button
							type="primary"
							htmlType="submit"
							block
							size="large"
							loading={loading}
						>
							Зарегистрироваться
						</Button>
					</Form.Item>
					<div style={LoginRedirectStyles}>
						<Text type="secondary">
							Уже есть аккаунт? <Link to="/login">Войти</Link>
						</Text>
					</div>
				</Form>
			</Card>
		</div>
	);
};

export default Register;
